import { useQuery } from "@tanstack/react-query";
import { notificationsApi } from "./client";

export const notificationsKeys = {
  summary: () => ["notifications", "summary"] as const,
};

const NOTIFICATIONS_REFETCH_MS = 60_000;

export function useAdminNotificationsQuery() {
  return useQuery({
    queryKey: notificationsKeys.summary(),
    queryFn: () => notificationsApi.getSummary(),
    refetchInterval: NOTIFICATIONS_REFETCH_MS,
    refetchIntervalInBackground: true,
  });
}
